import React, { PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import FormMultiSelectInput from "../../FormMultiSelectInput";
import Form, { DateInput, FormBody, SelectInput, SwitchInput, TextInput } from "../../Form";
import { observable } from "mobx";
import { getDisplayDate } from '../../../libs/date';
import { ticket } from '../api';
import RangeInput from '../../Form/RangeInput';

@inject('ticketStatusStore', 'ticketActionStore', 'ticketReasonStore', 'userStore', 'ticketStore', 'tagStore', 'stationStore', 'locationStore', 'locationTypeStore', 'reportingTemplateStore')
@observer
class TicketInfoTable extends React.Component {
  state = {
    search: ''
  };

  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  };

  @observable multiStationOptions = [];

  componentDidMount() {
    const { tagStore, ticketStore, locationStore, locationTypeStore } = this.props;

    if (!locationStore.items.length && !locationStore.isLoading) locationStore.fetchItems();
    if (!locationTypeStore.items.length && !locationTypeStore.isLoading) locationTypeStore.fetchItems();

    if (tagStore.items && tagStore.items.length > 0) {
      if (ticketStore.multiTagOptions.length === 0) {
        const newMultiTagOptions = tagStore.items.map(item => ({
          id: item.id,
          name: item.name,
          label: item.name,
          value: true
        }));

        ticketStore.setMultiTagOptions(newMultiTagOptions);
        ticketStore.onChangeSearchTags(newMultiTagOptions.filter(item => !!item.value).map(item => item.name));
      }
    } else {
      tagStore.fetchItems().then(() => {
        const newMultiTagOptions = tagStore.items.map(item => ({
          id: item.id,
          name: item.name,
          label: item.name,
          value: true
        }));

        ticketStore.setMultiTagOptions(newMultiTagOptions);
        ticketStore.onChangeSearchTags(newMultiTagOptions.filter(item => !!item.value).map(item => item.name));
      });
    }
    this.populateOptions();
  }

  populateOptions = () => {
    const { stationStore, ticketStore } = this.props;
    if (stationStore.items.length === 0) {
      setTimeout(() => {
        this.populateOptions();
      }, 300)
    } else {
      this.multiStationOptions = stationStore.items.map(item => ({ id: item.id, name: item.name, label: item.name, value: true, tags: item.tags }));
      ticketStore.onChangeSelectedStations(stationStore.items.map(item => +item.id));
    }
  };

  onChangeSelectedUser = (e) => {
    this.setState({
      search: e.target.value
    });
  };

  renderInfoTable = () => {
    const { ticketStatusStore, ticketActionStore, ticketReasonStore, ticketStore, userStore } = this.props;
    const { search } = this.state;
    let tickets = [];

    const markers = ticketStore.getMarkers();

    markers.map(item => {
      tickets.push(...item.tickets)
    });

    const rowStyle = (id) => ({ cursor: 'pointer', background: ticketStore.show === id ? '#e6e6e6' : 'white' });
    const filterSearchedUser = users => {
      if (this.state.search === '') return users;
      else return users.filter(u => (u.name && u.name.includes(search)) || (u.username && u.username.includes(search)) || (u.email && u.email.includes(search)));
    }
    const getTicketCount = (key, id) => !!tickets.length ? tickets.filter(item => +item[key] === +id).length : '-';

    return (
      <div className='bordered side-table'>
        <div className='DataTable'>
          <table>
            <tbody>
              {+ticketStore.viewBy === 1 && ticketStatusStore.items.map(item => (
                <tr onClick={() => ticketStore.onChangeShow(item.id)} style={rowStyle(item.id)} key={`status-${item.id}`}>
                  <td><i className='fa fa-circle' style={{ color: item.color }} /></td>
                  <td>{item.caption}</td>
                  <td>{getTicketCount('status_id', item.id)}</td>
                </tr>
              ))}
              {+ticketStore.viewBy === 2 && ticketReasonStore.items.map(item => (
                <tr onClick={() => ticketStore.onChangeShow(item.id)} style={rowStyle(item.id)} key={`reason-${item.id}`}>
                  <td><i className='fa fa-circle' style={{ color: item.color }} /></td>
                  <td>{item.caption}</td>
                  <td>{getTicketCount('reason_id', item.id)}</td>
                </tr>
              ))}
              {+ticketStore.viewBy === 3 && ticketActionStore.items.map(item => (
                <tr onClick={() => ticketStore.onChangeShow(item.id)} style={rowStyle(item.id)} key={`action-${item.id}`}>
                  <td><i className='fa fa-circle' style={{ color: item.color }} /></td>
                  <td>{item.caption}</td>
                  <td>{getTicketCount('action_id', item.id)}</td>
                </tr>
              ))}
              {+ticketStore.viewBy === 4 && filterSearchedUser(ticketStore.assignees).map(user => {
                return <tr onClick={() => ticketStore.onChangeShow(user.id)} style={rowStyle(user.id)} key={`assignee-${user.id}`} title={user.email}>
                  <td><i className='fa fa-circle' style={{ color: user.color }} /></td>
                  <td>{user.name}</td>
                  <td>{getTicketCount('assigned_to', user.id)}</td>
                </tr>
              })
              }
              {+ticketStore.viewBy === 5 && filterSearchedUser(ticketStore.assigners).map(user => {
                return <tr onClick={() => ticketStore.onChangeShow(user.id)} style={rowStyle(user.id)} key={`assigner-${user.id}`} title={user.email}>
                  <td><i className='fa fa-circle' style={{ color: user.color }} /></td>
                  <td>{user.name}</td>
                  <td>{getTicketCount('user_id', user.id)}</td>
                </tr>
              })
              }
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  onTagSelect = (item, onChangeSearchTags) => {
    item.value = !item.value;
    onChangeSearchTags(this.props.ticketStore.multiTagOptions.filter(item => !!item.value).map(item => item.name))
  }

  onStationSelect = (item) => {
    const { ticketStore } = this.props;
    item.value = !item.value;
    ticketStore.onChangeSelectedStations(this.multiStationOptions.filter(item => !!item.value).map(item => +item.id));
  }

  onStationSelectAll = stations => {
    const { ticketStore } = this.props;
    this.multiStationOptions = stations;
    ticketStore.onChangeSelectedStations(stations.filter(item => !!item.value).map(item => +item.id));
  }

  downloadReport = (e, format) => {
    e.preventDefault();
    const { ticketStore, stationStore, userStore, ticketStatusStore, ticketReasonStore, ticketActionStore, reportingTemplateStore } = this.props;
    let csv = ['S.No.,Ticket No.,Station Name,Division,District,Summary,Status,Reason,Action,Assigned To,Created On'];
    ticketStore.filteredTickets.forEach((item, i) => {
      let station = stationStore.findById(item.station_id),
        division = !!station && !!station.meta_data && station.meta_data.find(item => item.name === 'Division'),
        district = !!station && !!station.meta_data && station.meta_data.find(item => item.name === 'District');
      let user = userStore.findById(item.assigned_to);
      let status = ticketStatusStore.findById(item.status_id),
        reason = ticketReasonStore.findById(item.reason_id),
        action = ticketActionStore.findById(item.action_id);
      csv.push([
        i + 1,
        item.id,
        !!station ? station.name : '',
        !!division ? division.value : '',
        !!district ? district.value : '',
        item.summary || '',
        !!status ? status.caption : '',
        !!reason ? reason.caption : '',
        !!action ? action.caption : '',
        !!user ? user.name : '',
        !!item.last_log && !!item.last_log.log_date ? getDisplayDate(item.last_log.log_date) : getDisplayDate(item.generated_date),
      ].join(','));
    });
    reportingTemplateStore.downloadReport(
      csv.join('\n'),
      format,
      { report_name: 'Ticket Report', orientation: 'portrait' },
    );
  }

  archiveTickets = (e) => {
    e.preventDefault();
    const { notify, } = this.context;
    const { ticketStore } = this.props;
    if (!ticketStore.checkedTicketIds.length) {
      notify.error({ message: 'Tickets not selected' });
      return
    }
    ticket.ticket.archive(ticketStore.checkedTicketIds).then((res) => {
      notify.success({ message: 'Tickets archived' });
      ticketStore.checkedTicketIds = [];
      ticketStore.fetchItems();
    }).catch((err) => {
      notify.error({ message: err.message });
    });
  }

  _renderLocationFilterIinputs = () => {
    const { ticketStore, locationStore, locationTypeStore } = this.props;
    return (
      <div>
        <SelectInput label='Location Type' value={ticketStore.filters.location_type_id}
          options={[{ id: 0, name: 'All' }, ...locationTypeStore.items]} isLoading={locationTypeStore.isLoading}
          onChange={e => ticketStore.onChangeFilters('location_type_id', e)} fields={{ label: 'name', value: 'id' }} />
        {ticketStore.filters.location_type_id !== 0 && <SelectInput label='Location' value={ticketStore.filters.location_id}
          options={[{ id: 0, name: 'All' }, ...locationStore.items.filter(item => item.type_id === ticketStore.filters.location_type_id)]} isLoading={locationStore.isLoading}
          onChange={e => ticketStore.onChangeFilters('location_id', e)} fields={{ label: 'name', value: 'id' }}
        />}
      </div>
    )
  }

  render() {
    const { ticketStore, tagStore, stationStore } = this.props;
    const { onChangeSearchTags, filters } = ticketStore;

    return <div className='ticket-filter-group'>
      <Form>
        <FormBody>
          {/* <FormMultiSelectInput id='tag-multi-select' label='Tags' options={ticketStore.multiTagOptions} optionClicked={item => this.onTagSelect(item, onChangeSearchTags)} isLoading={tagStore.isLoading} /> */}
          <SwitchInput label='Filter By Location' value={filters.filter_by_location} onChange={() => ticketStore.onChangeFilters('filter_by_location', { target: { value: !filters.filter_by_location } })} />
          {!filters.filter_by_location &&
            <FormMultiSelectInput
              id='station-multi-select' label='Stations'
              options={this.multiStationOptions}
              optionClicked={this.onStationSelect}
              optionsChangeAll={this.onStationSelectAll}
              isLoading={stationStore.isLoading}
              filterOptions={stationStore.filterStations}
            />
          }
          {filters.filter_by_location && this._renderLocationFilterIinputs()}
          <DateInput type={'date'} label={'Date From'} value={ticketStore.filters.date_from} onChange={e => ticketStore.onChangeFilters('date_from', e)} />
          <DateInput type={'date'} label={'Date To'} value={ticketStore.filters.date_to} onChange={e => ticketStore.onChangeFilters('date_to', e)} />
          <RangeInput label='Open Duration' value={ticketStore.filters.open_duration} onChange={e => ticketStore.onChangeFilters('open_duration', e)} />
          <button onClick={e => this.archiveTickets(e)}>Archive selected tickets</button>
          <div className='flex' style={{ marginBottom: 10 }}>
            <button onClick={e => this.downloadReport(e, 'PDF')}>Print</button>
            <button onClick={e => this.downloadReport(e, 'CSV')}>Download CSV</button>
          </div>
        </FormBody>
      </Form>
      <div className='full-width overflow-x-scroll'>
        <div className='TabBar TabBarRounded'>
          <ul>{ticketStore.viewByOptions.map(({ id, name }) => (
            <li key={`ticket-view-by-options-${id}`}
              className={id === ticketStore.viewBy ? 'active' : ''}
              onClick={() => ticketStore.onChangeViewBy(id)}>
              <a>{name}</a>
            </li>
          ))}</ul>
        </div>
      </div>
      {[4, 5].includes(+ticketStore.viewBy) && <Form>
        <FormBody>
          <TextInput label={'Search User'} value={this.state.search} onChange={this.onChangeSelectedUser} />
        </FormBody>
      </Form>}
      {this.renderInfoTable()}
    </div>
  }
}

export default TicketInfoTable;



// WEBPACK FOOTER //
// ./src/components/Maintenance/Ticket/TicketInfoTable.js